
/*Package importing*/
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import ViewSampleModal from '../../components/modals/viewSampleModal';

/*Services*/
import devconfig from '../../config/config.js';
import APIGet from '../../services/apiCall/get';
import APIPost from '../../services/apiCall/post';

/*Assets*/

import Sample from '../../assets/images/sample/Banners.jpg';

import banner1 from '../../assets/images/sample/placeholder-1.png';
import banner2 from '../../assets/images/sample/placeholder-2.png';
import banner3 from '../../assets/images/sample/placeholder-3.png';
import banner4 from '../../assets/images/sample/placeholder-4.png';
import banner5 from '../../assets/images/sample/placeholder-5.png';
import banner6 from '../../assets/images/sample/placeholder-6.png';
import banner7 from '../../assets/images/sample/placeholder-7.png';
import banner9 from '../../assets/images/sample/placeholder-9.png';

class BannerStyleLocal extends Component {
  constructor(props){
    super(props);
    this.state = {
      data: this.props.data,
      bannerStyle: {},
      bannerStyles: [
        { id: 1, noOfFiles: 1, name: "Single Column", image: banner1 },
        { id: 2, noOfFiles: 2, name: "Two Column", image: banner2 },
        { id: 3, noOfFiles: 3, name: "Three Column", image: banner3 },
        { id: 4, noOfFiles: 4, name: "Four Column", image: banner4 },
        { id: 5, noOfFiles: 4, name: "Four Images", image: banner5 },
        { id: 6, noOfFiles: 5, name: "Five Images Banner", image: banner6 },
        { id: 7, noOfFiles: 6, name: "Image slider (Fullwidth)", image: banner7 },
        { id: 8, noOfFiles: 10, name: "Logo slider", image: banner4 },
        { id: 9, noOfFiles: 6, name: "2-Column 3-Row", image: banner9 },
      ]
    }
  }
  // category/all-list


  getCategories(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'category/selected-list';
    // var data = JSON.stringify({type: 2});
    APIGet(url).then(function(response){
      if(response.status == "ok"){
        console.log(response.data);
        if((this.props.data.adLocation.id===88||this.props.data.adLocation.id===182)){
          this.setState({ 
            categories: response.departments,
            products: response.sub_categories,
            apiLoading: false 
          });
        }
        else{
          this.setState({ 
            categories: response.departments,
            subcategories: response.categories,
            products: response.subcategories,
            apiLoading: false 
          });
        }
      }
    }.bind(this))
  }

  getLayoutCategories(){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'ads/selected-departments';
    var data = JSON.stringify({
      "ads_location_id": 81
    });
    APIPost(url, data).then(function(response){
      if(response.status == "ok" && response.data.length){
        let categoryOptions=[];
        response.data.forEach(element => {
          categoryOptions.push({label: element.department, value: element.id});
        });
        this.setState({ 
          categories: categoryOptions,
          apiLoading: false 
        });
      }
    }.bind(this))
  }

  getLayoutSubcategory(id){
    this.setState({apiLoading: true});
    var url = devconfig.vendor+ 'ads/selected-categories';
    var data = JSON.stringify({
      "ads_location_id": 88,
      "department_id": id
    });
    APIPost(url, data).then(function(response){
      if(response.status == "ok"){
        console.log(response.data);
        let subCategoryOptions=[];
        response.data.forEach(element => {
          subCategoryOptions.push({label: element.category, value: element.id});
        });
        this.setState({ 
          subcategories: subCategoryOptions,
          apiLoading: false 
        });
      }
    }.bind(this))
  }

  componentDidMount(){
    if(this.props.data.adLocation.id===81) this.getLayoutCategories();
    else this.getCategories();
    console.log(this.props.data)
  }

  selectChange = async (category) => {
    await this.setState({category: category});
    var data = this.state.data;
    if(this.props.data.adLocation.type==2) data['sub_category'] = category.value;
    else data['category'] = category.value;
    if((this.props.data.adLocation.id===88||this.props.data.adLocation.id===182)) this.setState({subcategories: []},()=>this.getLayoutSubcategory(category.value));
    this.setState({category: category, data: data})
  }

  selectSubChange(category){
    var data = this.state.data;
    data['sub_category'] = category.value;
    this.setState({subcategory: category, data: data})
  }

  nextStepClick(){
    this.props.nextStep(this.state.data);
  }

  selectStyle(bannerStyle){
    var data = this.state.data;
    data['bannerStyle'] = bannerStyle;
    this.setState({bannerStyle: bannerStyle, data: data})
  }

  // selectChange(category){

  // }


  render() {


    return (
      <div className="e-main-content e-vendor-table e-createAds">
        <h2 className="e-page-head">Create Ad's</h2>

        <div className="row">
          <div className="col-lg-12">
            <span className="e-selected-ad-type">Selected Ad Type: <b>{this.state.data.adLocation.ads_location}</b></span>
          <hr/>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 mb-2">
            <h6>Choose banner style</h6>
          </div>
        </div>


        <div>
          <div className="row">
            <div className="col-lg-12">
              <div className="e-vendor-category-list e-edit-ad">
                <div className="row">
                {
                  this.state.bannerStyles.map((bannerStyle, index)=>{
                    var allowedTypes = this.props.data.adLocation.allowed_types ? this.props.data.adLocation.allowed_types : []; 
                    if(allowedTypes.indexOf(bannerStyle.id)==-1){
                      return null
                    }
                    return(
                      <div className="col-lg-3 pt-3" onClick={this.selectStyle.bind(this, bannerStyle)}>
                        <div className={bannerStyle.id===this.state.bannerStyle.id ? "e-bannerwrap-active text-center" : "e-bannerwrap text-center"}>
                          <img src={bannerStyle.image} className="e-bannerstyle1" alt="Offer Banner"/>
                          <p className="pt-3">{bannerStyle.name}</p>
                        </div>
                      </div>
                    )
                  })
                }
                 
                 <div className="col-lg-12 mt-3 e-sample-link">
                  Click to view <a href={Sample} target="_blank">Banners Style</a>
                 </div> 
                </div>
                {
                  this.props.data.adLocation.type==2 ?
                    <div className="row mt-4">
                      <div className="col-lg-12">
                        <hr/>
                      </div>
                      <div className="col-lg-4">
                        <label className="e-ad-plan-select-label">Select the sub-category page to display the ad.</label>
                        <SelectBox defaultValue={this.state.deafaultCategory} options={this.state.subcategories} selectchange={this.selectChange.bind(this)} placeholder="Select sub category"/>
                      </div>
                    </div>
                  : this.props.data.adLocation.type==1?
                    <div className="row mt-4">
                      <div className="col-lg-12">
                        <hr/>
                      </div>
                      <div className="col-lg-4">
                        <label className="e-ad-plan-select-label">Select the category page to display the ad.</label>
                        <SelectBox defaultValue={this.state.filterDefault} options={this.state.categories} selectchange={this.selectChange.bind(this)} placeholder="Select category"/>
                      </div>
                    </div>
                  : null
                }
                 {
                   (this.props.data.adLocation.type==1 && (this.props.data.adLocation.id===88||this.props.data.adLocation.id===182))?
                   <div className="row mt-4">
                   <div className="col-lg-12">
                     <hr/>
                   </div>
                   <div className="col-lg-4">
                     <label className="e-ad-plan-select-label">Select the sub-category to display the ad.</label>
                     <SelectBox  options={this.state.subcategories} selectchange={this.selectSubChange.bind(this)} placeholder="Select sub category"/>
                   </div>
                 </div>
                 :
                 null
                 }   
                <div className="row pt-4">
                  <div className="col-lg-12">
                    {
                      this.state.bannerStyle.id &&
                      ((this.props.data.adLocation.type!=1 && this.props.data.adLocation.type!=2)||(this.state.category && this.state.category.value)) && 
                      (!(this.props.data.adLocation.type===1 && (this.props.data.adLocation.id===88||this.props.data.adLocation.id===182))||(this.state.subcategory && this.state.subcategory.value))?
                        <button className="e-s-btn" onClick={this.nextStepClick.bind(this)} type="submit" value="Submit">Next</button>
                      :
                        <button className="e-s-btn e-inactive" type="submit" value="Submit">Next</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/*Modals*/}
       <ViewSampleModal/>
      </div>

    );
  }
}

export default BannerStyleLocal;
